/**
 * LandingRedirect \u2014 sends the user to the first sidebar item their role can
 * see. Priority order favors the "natural" landing per role:
 *   admin / supervisor / agent  \u2192 Softphone (if granted) \u2192 ACD \u2192 \u2026
 *   viewer / client users       \u2192 ACD floor (no softphone) \u2192 Recordings \u2192 \u2026
 *
 * Driven entirely by the user's allowed module keys, so changes to the
 * Permissions matrix update behavior with no code change.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { permissionsApi } from '../api/client';

// Ordered list: first allowed module wins.
const PRIORITY = [
  { module: 'softphone',           to: '/softphone' },
  { module: 'acd_floor',           to: '/acd/floor' },
  { module: 'acd_queues',          to: '/acd/queues' },
  { module: 'acd_personal',        to: '/acd/personal' },
  { module: 'recordings_browser',  to: '/recordings' },
  { module: 'reports',             to: '/reports' },
  { module: 'admin_agents',        to: '/admin/agents' },
  { module: 'admin_queues',        to: '/admin/queues' },
  { module: 'admin_recording',     to: '/admin/recording' },
  { module: 'settings_permissions',to: '/settings/permissions' },
  { module: 'account',             to: '/account' },
];

export default function LandingRedirect() {
  const { data: perms, isLoading } = useQuery({
    queryKey: ['permissions', 'me'],
    queryFn: () => permissionsApi.me(),
    staleTime: 60_000,
  });
  if (isLoading) return null;
  const allowed = new Set(perms?.is_admin
    ? PRIORITY.map((p) => p.module)
    : (perms?.modules || []));
  const target = PRIORITY.find((p) => allowed.has(p.module));
  return <Navigate to={target?.to || '/account'} replace />;
}
